"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Globals = /** @class */function () {
  function Globals() {}
  Globals.version = "TS Dive SDK 1.6.8";
  Globals.settings_url = 'https://public.dive.games/sdk';
  Globals.events_path = '/events';
  Globals.id_type = "DIVE_DEVICE_ID";
  Globals.platform = 'web';
  Globals.SESSION_ID_KEY = 'suid';
  Globals.DIGEST_KEY = 'dive-digest';
  Globals.COOKIE_PATCH = true;
  return Globals;
}();
exports.default = Globals;